/**
 * 自定义组件最简结构
 */
import React from "react";
import PropTypes from "prop-types";
import { component_tool } from "@/tool";
import { Link } from "dva/router";
import './index.less'
const { WizComponent } = component_tool;
const { WizDivider } = component_tool

export default class CustomFooter extends WizComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { menulist, copyright, beian } = this.props;
    return (
      <div className="footer">
        {
          menulist.length ? 
            <ul className="footer-menu">
              {
                menulist.map((val, index) => 
                  <React.Fragment key={index}>
                    <li className="footer-menu-item">
                      <img className="footer-menu-item__icon" src={val.icon} alt="" />
                      <Link to={val.path} className="footer-menu-item__text">{val.text}</Link>
                    </li> 
                    { index === menulist.length - 1 ? null : <WizDivider className="tablet-hidden" type="vertical" /> }
                  </React.Fragment>
                )
              }
            </ul> : null
        }
        <p className="copyright">{copyright} {beian && <a href='https://beian.miit.gov.cn/' target='_blank'>{beian}</a>}</p>
      </div>
    );
  }
}

/**
 * 默认值
 */
CustomFooter.defaultProps = {
  menulist: [],
  copyright: '',
  beian: '',
};

/**
 * props入参校验
 */
CustomFooter.propTypes = {
  /**
   * 数据源data
   */
  menulist: PropTypes.array,
  copyright: PropTypes.string,
  beian: PropTypes.string,
};
